import React from 'react';
import { Formik, Form, Field } from 'formik';

import { Button, Select, Input, useToast, GridItem, Grid, Heading, Box, Text } from '@chakra-ui/react';

import { useParams } from 'react-router-dom';

import DatePicker from 'components/datePicker/DatePicker';

import * as Yup from 'yup';

import xhr from 'xhr';

import { detectVideoDuration, EMPTY_INTERACTIONS } from './interactiveVideo/interactionsSpec';

export default function InsertInteractiveVideo(props) {
  const { dataMaterials, select, setIsOpen } = props;
  const params = useParams();

  const toasts = useToast();

  const [loadingButton, setLoadingButton] = React.useState(false);
  const [dateFilter, setDateFilter] = React.useState(null);
  const [dateFilterEnd, setDateFilterEnd] = React.useState(null);
  const [durationSeconds, setDurationSeconds] = React.useState(null);

  const handleDateChange = (date) => {
    setDateFilter(date);
  };

  const handleDateChangeEnd = (date) => {
    setDateFilterEnd(date);
  };

  const handleSourceBlur = async (e) => {
    const url = e.target.value;
    if (!url) return;
    const seconds = await detectVideoDuration(url);
    setDurationSeconds(seconds);
  };

  const handleInteractiveVideo = async (values, action) => {
    try {
      setLoadingButton(true);

      const responseVideo = await xhr.post(`/videos/`, {
        data: {
          title: values.title,
          source: values.source,
          interactions: EMPTY_INTERACTIONS,
          duration_seconds: durationSeconds,
        },
      });

      const response = await xhr.post(`/materials/`, {
        data: {
          ...values,
          video: responseVideo.data.data.id,
          module: params.idModule,
          type: select,
          enabled_date: dateFilter,
          enabled_date_end: dateFilterEnd,
        },
      });
      toasts({
        title: 'El material se creó correctamente!',
        description: 'Agrega las preguntas del video desde la opción Editar del material.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // El POST de materials no trae video populado; sin este GET el Editar
      // inmediato muestra título/source vacíos y el player en negro.
      const getPopulate = await xhr(`/materials/${response.data.data.id}?populate=*`);
      dataMaterials(getPopulate.data.data);
      setIsOpen(false);

      action.resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };

  const RequerimentSchema = Yup.object().shape({
    title: Yup.string().required('Requerido'),
    order: Yup.string().required('Requerido'),
    duration: Yup.string().required('Requerido'),
    source: Yup.string().required('Requerido'),
  });
  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          title: '',
          order: '',
          duration: '',
          source: '',
        }}
        validationSchema={RequerimentSchema}
        onSubmit={handleInteractiveVideo}
      >
        <Form>
          <Grid templateColumns="repeat(12, 1fr)" gap={6}>
            <GridItem colSpan={6}>
              <Box marginTop="20px">
                <Heading use="h3" width="100%">
                  Material
                </Heading>
              </Box>
              <Grid marginTop="20px" gap={4}>
                <GridItem colSpan={6}>
                  <Box>Título</Box>
                  <Field marginTop="20px" as={Input} name="title" />
                </GridItem>

                <GridItem colSpan={3}>
                  <Box>Orden</Box>
                  <Field marginTop="20px" as={Input} type="number" name="order" />
                </GridItem>

                <GridItem colSpan={3}>
                  <Box>Duración</Box>
                  <Field marginTop="20px" as={Input} type="number" name="duration" />
                </GridItem>

                <GridItem colSpan={6}>
                  <Box color="#636363">Periodo</Box>
                  <Field marginTop="20px" name="period" as={Select}>
                    <option value=""></option>
                    <option value="primero">primer</option>
                    <option value="segundo">segundo</option>
                    <option value="tercero">tercer</option>
                    <option value="cuarto">cuarto</option>
                  </Field>
                </GridItem>
                <GridItem colSpan={12}>
                  <br />
                  <Box color="#636363">Fecha Inicio</Box>
                  <DatePicker date={dateFilter} placeholder="Fecha Inicio" onChange={handleDateChange} />
                  <br />
                  <Box color="#636363">Fecha Fin</Box>
                  <DatePicker date={dateFilterEnd} placeholder="Fecha Fin" onChange={handleDateChangeEnd} />

                  <br />
                </GridItem>
              </Grid>
            </GridItem>

            <GridItem colSpan={6} marginTop="30px" paddingLeft="20px" borderLeft="1px solid" borderColor="gray.200">
              <Box marginBottom="20px" position="relative" top="-10px">
                <Heading use="h3" width="100%">
                  Vídeo interactivo
                </Heading>
              </Box>

              <Box marginTop="20px">URL</Box>
              <Field marginTop="20px" as={Input} name="source" onBlur={handleSourceBlur} />

              {durationSeconds && (
                <Text marginTop="10px" fontSize="14px" color="#727d90">
                  Duración detectada: {Math.floor(durationSeconds / 60)}m {durationSeconds % 60}s
                </Text>
              )}

              <Text marginTop="20px" fontSize="14px" color="#727d90">
                Las preguntas y puntos de pausa se configuran después de crear el material, desde la opción
                Editar.
              </Text>
            </GridItem>
          </Grid>

          <Button
            type="submit"
            colorScheme="#574feb"
            bg="#574feb"
            marginY="10px"
            width="140px"
            isLoading={loadingButton}
            disabled={loadingButton}
          >
            Crear
          </Button>
        </Form>
      </Formik>
      <style jsx global>{`
        input {
          font-size: 18px !important;
        }
        .css-kekc4e {
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
}
